import { gql } from '@apollo/client'
import { useCleanFilterForRequest, useSearch, useSort } from '@btime/react-contexts'
import React from 'react'

import { accountsClient } from '../../../../utils/apollo/api'
import { usePaginatedQuery } from '../../../../utils/apollo/_helpers/pagination'
import LazyAction from '../../../../components/helpers/LazyAction'
import StatePresenter from '../../../../components/helpers/StatePresenter'

const Context = React.createContext()
const { Provider } = Context
export const useProjectsState = () => React.useContext(Context) || {}
export const useProjects = () => useProjectsState()?.projects || []

const QUERY = gql`
  query Projects($page: Int, $search: String, $sort: ProjectSort, $filter: ProjectFilter) {
    projects(page: $page, search: $search, sort: $sort, fromTemplates: true, filter: $filter) {
      id
      name
      icon
      color
    }
  }
`

const ProjectsLoader = ({ children, fromTemplates, uncontrolledChildren }) => {
  const { field, type } = useSort()
  const search = useSearch()
  const filter = useCleanFilterForRequest()

  const { data, fetchMore, variables, ...state } = usePaginatedQuery(QUERY, {
    variables: {
      page: 1,
      search,
      sort: { field: field || 'NAME', type },
      fromTemplates,
      filter: { ...filter }
    },
    client: accountsClient
  })

  return (
    <Provider value={data}>
      <StatePresenter {...state} uncontrolledChildren={uncontrolledChildren} empty={false}>
        {children}
        <LazyAction action={fetchMore} waiting={state.loading} />
      </StatePresenter>
    </Provider>
  )
}

export default ProjectsLoader
